import { render, staticRenderFns } from "./InformationsTiersForm.vue?vue&type=template&id=28b92c73&"
import script from "./InformationsTiersForm.vue?vue&type=script&lang=js&"
export * from "./InformationsTiersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports